View = require 'app/scripts/views/internal/view'
attachmentThumbProcessingTemplate = require 'app/scripts/views/templates/attachment_thumb_processing'

module.exports = class InProgressAttachmentView extends View
  render: ->
    @$el.html(attachmentThumbProcessingTemplate())
    @
